import React from 'react';
import { SignIn } from '../components';
import landingOne from '../../src/assets/svg/landingOne.svg';

const Login = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 flex items-center justify-center p-4">
      <section className='flex items-center justify-center w-full max-w-7xl mx-auto gap-16 lg:gap-24'>
        {/* Left side - Your SVG with improved styling */}
        <div className="hidden md:flex md:w-1/2 lg:w-2/5 justify-center">
          <div className="relative">
            {/* Background decoration */}
            <div className="absolute inset-0 bg-gradient-to-r from-blue-400/10 to-indigo-400/10 rounded-3xl transform rotate-3"></div>
            <div className="absolute inset-0 bg-gradient-to-r from-indigo-400/10 to-purple-400/10 rounded-3xl transform -rotate-3"></div>
            
            {/* SVG Container */}
            <div className="relative bg-white/60 backdrop-blur-sm rounded-2xl p-8 shadow-lg border border-white/40">
              <img 
                src={landingOne} 
                alt='Welcome illustration' 
                className='w-full h-auto max-w-md mx-auto' 
              />
            </div>
          </div>
        </div>

        {/* Right side - Your SignIn component without background */}
        <div className='w-full md:w-1/2 lg:w-2/5 max-w-md mx-auto'>
          <SignIn />
        </div>
      </section>
    </div>
  );
};

export default Login;